import _ from 'lodash';
function transformTitle(title) {
  const words = title.split('_');
  const capitalizedWords = words.map(
    word => word?.charAt(0)?.toUpperCase() + word?.slice(1)
  );
  return capitalizedWords.join('');
}

export function convertToQueryString(data) {
  const queryStringArr = [];

  for (const key in data) {
    if (Object.hasOwnProperty.call(data, key)) {
      const { filterModes, operator, title } = data[key];

      const transformedTitle = transformTitle(key);
      const filterStringArr = filterModes?.map(
        ({ mode, value }) =>
          `[${operator},${mode},${encodeURIComponent(value) || 'null'}]`
      );
      const filterString = filterStringArr?.join('||');

      queryStringArr?.push(`FBy${transformedTitle}=${filterString}`);
    }
  }

  return queryStringArr?.join('&');
}

/**
 * Normalize filter state for equality checks.
 * Ignores random UI keys and treats "+" / space the same so URL sync
 * does not dispatch in an infinite loop.
 */
export function normalizeFiltersForCompare(data) {
  if (!data || typeof data !== 'object') return {};

  return Object.keys(data)
    .sort()
    .reduce((acc, key) => {
      const column = data[key];
      if (!column?.filterModes) return acc;

      acc[key] = {
        operator: column.operator,
        filterModes: column.filterModes.map(({ mode, value }) => ({
          mode: String(mode ?? ''),
          value: String(value ?? '').replace(/\+/g, ' ')
        }))
      };
      return acc;
    }, {});
}

export function areFilterStatesEqual(a, b) {
  return _.isEqual(normalizeFiltersForCompare(a), normalizeFiltersForCompare(b));
}
export function parseQueryString(queryString) {
  const pairs = queryString.slice(1).split('&');
  const result = {};

  for (const pair of pairs) {
    const [key, value] = pair.split('=');

    if (key && value) {
      const decodedKey = decodeURIComponent(key);
      const decodedValue = decodeURIComponent(value);

      const keyParts = decodedKey.match(/FBy(.+)/);
      if (keyParts && keyParts[1]) {
        const transformedTitle = keyParts[1];
        const words = transformedTitle.split(/(?=[A-Z0-9])/);
        const modifiedKey = words.map(word => word.toLowerCase()).join('_');
        const existingData = result[modifiedKey] || { filterModes: [] };

        // Stable ids for the same URL. A random key changes every parse and
        // makes RTK Query treat each render as a new request (endless loading).
        let counter = existingData.filterModes.length;

        // Split multiple filters separated by ||
        const filters = decodedValue.split('||');
        for (const filter of filters) {
          const [, operator, mode, modeValue] =
            filter.match(/\[(.+?),(.+?),(.+?)\]/) || [];
          if (operator && mode && modeValue) {
            counter += 1;
            existingData.filterModes.push({
              key: counter,
              mode,
              value: modeValue.replace(/\+/g, ' ')
            });
            existingData.operator = operator;
            existingData.title = '';
          }
        }

        result[modifiedKey] = existingData;
      }
    }
  }

  return result;
}

export function getQueryStringKeys(queryString, validKeys) {
  const queryParams = new URLSearchParams(queryString);
  const filteredKeys = Array.from(queryParams.keys()).filter(
    key => key.startsWith('FBy') || validKeys.includes(key)
  );
  return filteredKeys;
}

export function isPresentQueryValue(value) {
  return value != null && value !== '' && value !== 'null';
}

export function generateQueryStringByKeys(urlParams, queriesArray) {
  const preQueries = {};
  if (queriesArray.length !== 0) {
    queriesArray.forEach(item => {
      const value = urlParams.get(item);
      if (isPresentQueryValue(value)) {
        preQueries[item] = value;
      }
    });
  }
  return preQueries;
}
